import { FormHelperText, Typography } from '@material-ui/core'
import { TagPicker } from 'rsuite'
import { makeStyles } from '@material-ui/core/styles'
import { useErrors } from '@/hooks/ErrorsStateContext'
import { useInputState } from '@/hooks/inputStateContext'
import React from 'react'
import _ from 'lodash'

/**
 *
 * @param {*} props
 * @returns
 */
export default function MultiSelectControl (props) {
  const { setting } = props
  const [inputState, updateInputState] = useInputState()
  const [errors, setErrors] = useErrors()
  const classes = useStyles(props)
  const handleChange = (e) => {
    updateInputState(setting.paramaterName, e)
    setErrors({ ...errors, [setting.paramaterName]: undefined })
  }
  const value = _.get(inputState, setting.paramaterName, [])
  const fieldError = _.get(errors, setting.paramaterName)
  return (
    <div>
      <div className={classes.tagLine}>
        <Typography className={classes.label}>{setting.label}</Typography>
        <TagPicker
          onChange={handleChange}
          value={value}
          data={setting.items}
          placeholder={setting.label}
          style={{ width: 300 }}
          {...setting.inputProps}
        />
      </div>
      {fieldError && (
        <FormHelperText error className={classes.helperText}>
          {fieldError}
        </FormHelperText>
      )}
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  tagLine: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  helperText: {
    textAlign: 'right',
    marginTop: 0,
    marginBottom: 4,
  },
}))
